import React from 'react';

/**
 * Reusable heading + description block for product sections.
 */
export default function HeadingDescription({ heading, description, level = 2, className = '', hideLine = false }) {
  const Tag = level === 1 ? 'h1' : level === 2 ? 'h2' : level === 4 ? 'h4' : 'h3';
  const desc = Array.isArray(description) ? description : (description ? [description] : []);

  return (
    <div className={`quotation-section quotation-no-break ${className}`} style={{ marginBottom: 20 }}>
      {heading && (
        <>
          <Tag
            style={{
              fontFamily: "'Montserrat', sans-serif",
              fontWeight: 700,
              fontSize: level === 1 ? 22 : level === 2 ? 18 : level === 3 ? 16 : 14,
              color: '#000814',
              margin: '0 0 8px 0',
            }}
          >
            {heading}
          </Tag>
          {!hideLine && <div
            className="quotation-yellow-divider"
            style={{ height: 2, width: '100%', maxWidth: 80, margin: '4px 0 12px 0', background: 'linear-gradient(90deg, #ffbe0b 0%, transparent 100%)' }}
          />}
        </>
      )}
      {desc.length > 0 && desc.map((p, i) => (
        <p
          key={i}
          style={{
            fontSize: 13,
            color: '#333',
            lineHeight: 1.65,
            margin: '0 0 8px 0',
          }}
        >
          {p}
        </p>
      ))}
    </div>
  );
}
